import {
  Button,
  Icon,
  Menu,
  MenuTrigger,
  type PressEvent,
} from '@iconik-io/uad';

import {
  ColorMenuItem,
  type ColorMenuItemProps,
} from '../color_menu_item/color_menu_item';

type ColorSelectMenuProps = {
  onPress?: (e: PressEvent) => void;
  colorItems: ColorMenuItemProps[];
  selection: string | null;
  onSelectionChange?: (key: string | null) => void;
};

export function ColorSelectMenu({
  colorItems,
  onSelectionChange,
  onPress,
  selection,
}: ColorSelectMenuProps) {
  const colorItemsMapped = colorItems.map((item) => ({
    id: item.value,
    element: <ColorMenuItem label={item.label} value={item.value} />,
  }));

  return (
    <MenuTrigger>
      <Button
        size="s"
        variant="tertiary"
        onPress={onPress}
        icon={<Icon name="annotation_color_palette" />}
        aria-label="Comment color menu button"
      />
      <Menu
        items={colorItemsMapped}
        selectionMode="single"
        selection={selection}
        onSelectionChange={onSelectionChange}
      />
    </MenuTrigger>
  );
}
